// File: noviopus-ats-client/src/components/Toastr/index.tsx
import React, { useContext } from 'react';
import Snackbar from 'material-ui/Snackbar';
import { useSelector, useDispatch } from 'react-redux';
import { IToast } from '@/types/toast';
import { createStyleSheet } from 'jss-theme-reactor';
import { StyleManagerContext } from '@/styles/StyleManagerContext';

import { toastrActionTriggered, hideActiveToast } from './actions';
import { getActiveToast } from './selectors';
import Message from './Message';

const noop = () => {};

export const styleSheet = createStyleSheet('Toastr', (theme: any) => {
  return {
    root: {
      width: '100%',
      height: '48px', // Slightly taller for modern look
      '& > div': {
        backgroundColor: '#323232', // Modern dark charcoal background
        color: '#ffffff', // White text
        width: '100%',
        maxWidth: 'unset',
        minWidth: 'unset',
        height: '100%',
        padding: 0,
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
        '& > div': {
          height: '100%',
          fontSize: '14px', // Slightly larger font
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& > span': {
            lineHeight: '16px',
          },
        },
      },
      '& > div > div > span': {
        width: '100%',
      },
      '& button': {
        textDecoration: 'none', // Remove underline
        color: '#1AC5C0', // Make the UNDO button teal
        fontWeight: 'bold',
        height: '100%',
        lineHeight: '26px',
        padding: '0 16px',
        borderRadius: '4px',
        transition: 'background-color 0.2s',
        '&:hover': {
            backgroundColor: 'rgba(26, 197, 192, 0.1)', // Subtle teal hover effect
        },
        '& span': {
          textTransform: 'uppercase',
          fontSize: 14,
          verticalAlign: 'unset',
        },
      },
    },
  };
});

const Toastr: React.FC = () => {
  const dispatch = useDispatch();
  const activeToast: IToast | null = useSelector((state: any) => getActiveToast(state));
  
  const { styleManager } = useContext(StyleManagerContext);
  const classes = styleManager.render(styleSheet);
  
  // {{ UPDATED TO RECEIVE PAYLOAD }}
  const handleAction = (action: string, payload?: any) => {
    dispatch(toastrActionTriggered(action, payload));
    handleClose();
  };
  
  const handleClose = () => {
    dispatch(hideActiveToast());
  };
  
  if (!activeToast) {
      return null;
  }

  // Handle POJO or Immutable toast structure safely
  const toastData = (activeToast as any)?.toJS ? (activeToast as any).toJS() : activeToast;
  const duration = toastData.timeout || 5000;

  return (
    <div>
      <Snackbar
        open={!!activeToast}
        message={
          <Message
            message={toastData.message || ''}
            action={toastData.action || ''}
            actionPayload={toastData.payload}
            onAction={handleAction}
            onClose={handleClose}
          />
        }
        autoHideDuration={duration}
        onRequestClose={noop}
        className={classes.root}
      />
    </div>
  );
};

export default Toastr;